<style scoped>

</style>

<template>
    <div>
        <h1>任务总览</h1>
        <div>
            <el-table :data="taskList" border style="width:100%">
                <el-table-column prop="taskSequence" label="需求ID" width="150"></el-table-column>
                <el-table-column prop="operateTime" label="操作时间" width="200"></el-table-column>
                <el-table-column prop="uploadTime" label="上传时限" width="100"></el-table-column>
                <el-table-column prop="taskType" label="需求来源" :formatter="taskTypeFormatter" width="150"></el-table-column>
                <el-table-column prop="desc" label="需求描述" width="400"></el-table-column>
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status!=1" @click="finishTask(scope.row)" type="primary" size="small">上传视频</el-button>
                        <el-button v-if="scope.row.status==1" type="default" disabled size="small">已上传视频</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page="currentPage" :page-size="pageSize" @current-change="pageCurrentChange"
            background layout="prev, pager, next" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import app from '@/App.vue';
import {getTaskList, finishTask} from '@/request/api';
export default {
    name: 'User',
    data() {
      return {
        currentPage: 1,
        pageSize: 10,
        pages: 1,
        total: 0,
        taskList: [{

        }],
      }
    },
    methods: {
        finishTask(row) {
            this.$router.push("/Layout/uploadCover?taskId=" + row.taskId + "&dailyRecordId=" + row.dailyRecordId).catch(error => error);
            return;
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            finishTask({
                taskId: row.taskId,
                dailyRecordId: row.dailyRecordId
            }).then(res => {
                var status = res.status;
                var msg = res.msg;
                if (status === '2') {
                    this.$message.error(msg);
                } else {
                    this.$message.success("操作成功");
                    this.onSubmit();
                }
                loading.close();
            })
        },
        onSubmit() {
            getTaskList({
                page: this.currentPage,
                size: this.pageSize
            }).then(res => {
                var status = res.status;
                var msg = res.msg;
                if (status === '2') {
                    this.$message.error(msg);
                } else {
                    this.$message.success("查询成功");
                    var data = res.data;
                    this.taskList = data.list;
                    this.currentPage = data.pageNum;
                    this.pagea = data.pages;
                    this.total = data.total;
                }
            })
        },
        pageCurrentChange(val) {
            this.currentPage = val;
            this.onSubmit()
        },
        taskTypeFormatter(data) {
            if (data.taskType === 0) {
                return '初始';
            }
            if (data.taskType === 1) {
                return '猫卡操作';
            }
            if (data.taskType === 2) {
                return '每日活动';
            }
        }
    },
    created(){
        this.onSubmit();
    }
}
</script>



// WEBPACK FOOTER //
// src/page/task/taskConfig.vue